// import jQuery from 'CommonScripts/jquery-1.10.2'; 

(function (window, document, $) {

    $(document).ready(function () {        

        //$.components.registerComponent('.search-field', function ($root) {
            var $root = document.querySelectorAll('.search-field');
            $root = $($root); 
            var quickSearch = {
                dom: {
                    input: $root.find('input'),
                    clearBtn: $root.find('.icon-cross'),
                    searchButton: $root.parent().find('.button a'),
                    suggestBox: $root.find('.search-suggest')
                },
                set: {
                    fullSearchUrl: $root.data('full-search-url'),
                    suggestUrl: '/services/Marketing/SearchSuggest.asmx/Suggest',
                    activeClass: 'active',
                    activeSuggestionClass: 'active-suggest',
                    upKey: 38,
                    downKey: 40,
                    enterKey: 13,
                    activeIndex: 0,
                    maxIndex: 0,
        },
                fn: {                    
                    getSuggestions: function () {
                        if ($dom.input.val().length <= 2 || $dom.input.attr('data-siteid') == undefined) {
                            $fn.clearSuggestionBox();
                            return;
                        }



                        $.ajax({
                            type: "POST",
                            url: $set.suggestUrl,
                            data: "{searchTerm:'" + $dom.input.val() + "',siteId:'" + $dom.input.attr('data-siteid') + "'}",
                            dataType: "json",
                            contentType: "application/json; charset=utf-8",
                            success: function (data) {
                                var cats = new Array();

                                $.each(data.d, function (index, value) {
                                    var result = value;
                                    cats.push('<div><li>' + result + '</li></div>');
                                });

                                if (data.d.length > 0) {
                                    $fn.renderSuggestions(cats);
                                    $set.maxIndex = data.d.length;
                                    $set.activeIndex = 0;
                                    $dom.suggestBox.show();
                                } else {
                                    $fn.clearSuggestionBox();
                                }
                                
                                

                            },
                            error: function (a, b, c) {
                            }
                        });
                    },

                    renderSuggestions: function(sug){ 
                         $dom.suggestBox.html('<ul>' + sug.join('') + '</ul>');
                         $dom.suggestBox.find('li').click(function (event) {
                            $dom.input.val($(event.target).text());
                            var e = $.Event('keydown');
                            e.which = $set.enterKey;
                            $dom.input.trigger(e);
                            $fn.clearSuggestionBox();
                         });

                        
                         $fn.showSuggestionBox();
                    },
                    showSuggestionBox: function () {
                        if (!$dom.suggestBox.hasClass($set.activeClass) && $dom.input.val()) {
                            $dom.suggestBox.addClass($set.activeClass);
                        }
                    },
                    clearSuggestionBox: function () {
                        $set.activeIndex = 0;
                        $set.maxIndex = 0;
                        $dom.suggestBox.html("");
                        $dom.suggestBox.removeClass($set.activeClass);
                        $dom.suggestBox.hide();
                    },
                    clearActiveSuggestion: function() {
                        var suggestion = $fn.getActiveSuggestion();
                        if (suggestion) {
                            suggestion.removeClass($set.activeSuggestionClass);
                        };
                    },
                    getActiveSuggestion: function() {
                        return   $dom.suggestBox.find('.' + $set.activeSuggestionClass);
                    },
                    changeActiveSuggestion: function (index) {                        
                        $fn.clearActiveSuggestion();
                        if (index <= 0) {
                            return;
                        }

                        $dom.suggestBox.find("ul div:nth-child(" + index + ")").addClass($set.activeSuggestionClass);

                    }
                }
            },
            /* Add quick access variables to be used in local function
             * Keep main variable name in case it needs to be shared with other JS files
             */
            $dom = quickSearch.dom,
            $set = quickSearch.set,
            $fn = quickSearch.fn;

            $dom.input.on({
                keydown: function (event) {
                    
                    switch (event.keyCode) {
                        //up
                        case $set.upKey:
                            if ($set.activeIndex > 0) {
                                $set.activeIndex--;
                                $fn.changeActiveSuggestion($set.activeIndex);
                            }                            
                            event.preventDefault();
                            break;
                            //down
                        case $set.downKey:
                            if ($set.activeIndex < $set.maxIndex) {
                                $set.activeIndex ++;
                                $fn.changeActiveSuggestion($set.activeIndex);
                            }                            
                            event.preventDefault();
                            break;
                        case $set.enterKey:
                            if ($set.activeIndex != 0) {
                                $dom.input.val($($fn.getActiveSuggestion()).text());
                            }                            
                            $dom.searchButton.click();
                            $fn.clearSuggestionBox();
                            break;
                    }
                    
                },

                keyup: function (event) {

                    switch (event.keyCode) {
                        //up
                        case $set.upKey:                            
                            event.preventDefault();
                            break;
                            //down
                        case $set.downKey:

                            event.preventDefault();
                            break;
                        case $set.enterKey:
                            break;
                        default:
                            $fn.getSuggestions();
                    }
                },

                
                
            });

            $dom.suggestBox.on({
                mousedown: function(event) {
                    event.preventDefault();
                },
            });

            $dom.input.on({
                focus: function(event) {
                    $fn.getSuggestions();
                },

                blur: function(event) {
                    $fn.clearSuggestionBox();
                }
            });

            $dom.clearBtn.on({
                click: function () {
                    $fn.clearSuggestionBox();
                }
            });

        //});



    });

})(window, document, jQuery);